import I18N from "@/i18n";

export function translateWithRequired(code: string) {
  return `* ${I18N.t(code).toString()}`;
}
